var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddTextbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99902 0.124512C8.37872 0.124512 8.68652 0.432316 8.68652 0.812012V13.187C8.68652 13.5667 8.37872 13.8745 7.99902 13.8745C7.61933 13.8745 7.31152 13.5667 7.31152 13.187V0.812012C7.31152 0.432316 7.61933 0.124512 7.99902 0.124512Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.436523 0.812012C0.436523 0.432316 0.744328 0.124512 1.12402 0.124512H14.874C15.2537 0.124512 15.5615 0.432316 15.5615 0.812012V3.56201C15.5615 3.94171 15.2537 4.24951 14.874 4.24951C14.4943 4.24951 14.1865 3.94171 14.1865 3.56201V1.49951H1.81152V3.56201C1.81152 3.94171 1.50372 4.24951 1.12402 4.24951C0.744328 4.24951 0.436523 3.94171 0.436523 3.56201V0.812012Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56152 13.187C4.56152 12.8073 4.86933 12.4995 5.24902 12.4995H10.749C11.1287 12.4995 11.4365 12.8073 11.4365 13.187C11.4365 13.5667 11.1287 13.8745 10.749 13.8745H5.24902C4.86933 13.8745 4.56152 13.5667 4.56152 13.187Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTextbox);
export default __webpack_public_path__ + "static/media/add_textbox.2daed20c.svg";
export { ForwardRef as ReactComponent };